export function buildAmenityOptions({
  groceryCount,
  gymCount,
  favoriteCount,
  hotSpringCount,
  skiResortCount,
  showThingsToDo,
}) {
  const options = [];

  if (groceryCount > 0) {
    options.push({ key: 'grocery', label: `Grocery stores (${groceryCount})` });
  }
  if (gymCount > 0) {
    options.push({ key: 'gyms', label: `Gyms (${gymCount})` });
  }
  if (favoriteCount > 0) {
    options.push({ key: 'favorites', label: `Favorites (${favoriteCount})` });
  }
  if (showThingsToDo && hotSpringCount > 0) {
    options.push({ key: 'hotSprings', label: `Hot springs (${hotSpringCount})` });
  }
  if (showThingsToDo && skiResortCount > 0) {
    options.push({ key: 'skiResorts', label: `Ski resorts (${skiResortCount})` });
  }

  return options;
}

export function buildAmenityMarkerGroups({
  showStoreMarkers,
  showGymMarkers,
  amenityVisibility,
  groceryStores,
  favoriteStores,
  gyms,
}) {
  return [
    {
      key: 'grocery',
      enabled: showStoreMarkers && amenityVisibility.grocery,
      items: groceryStores,
      type: 'grocery',
      markerPrefix: 'store',
    },
    {
      key: 'favorites',
      enabled: showStoreMarkers && amenityVisibility.favorites,
      items: favoriteStores,
      type: 'grocery',
      markerPrefix: 'store',
    },
    {
      key: 'gyms',
      enabled: showGymMarkers && amenityVisibility.gyms,
      items: gyms,
      type: 'gym',
      markerPrefix: 'gym',
    },
  ];
}
